import React from "react";
import { UEListData } from "@/app/interface/homepage";
import DownloadIcon from "@/app/assets/icons/download-icon";

interface BoardManagementProps {
    filteredData: UEListData;
    compact:boolean;
}

const BoardManagement: React.FC<BoardManagementProps> = ({ filteredData,compact }) => {
    const companyDescription = filteredData?.company?.description || "";

    return (
        <div
            className={`${compact ? "flex bg-white sm:container" : "flex bg-white px-5 py-10 sm:container"}`}
        >
            <div className="w-full max-w-[812px]">
                <h2 className="mb-6 text-xl font-semibold sm:text-3xl">About Co.</h2>
                {/* Company Description */}
                <p className="mb-12 leading-relaxed text-gray-700">{companyDescription}</p>

                {/* Board of Directors Section */}
                <section className="mb-12">
                    <h2 className="mb-8 text-2xl font-semibold text-gray-900">
                        Board of Directors & Management
                    </h2>

                    <h3 className="mb-6 text-xl font-semibold text-gray-800">Board of Directors</h3>

                    <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 md:grid-cols-3">
                        {filteredData?.boardOfDirectors?.map((director, index) => (
                            <div key={index} className="mb-6">
                                <h4 className="mb-1 font-semibold text-black">
                                    {director?.fullName}
                                </h4>
                                <p className="text-sm text-gray-600">{director?.designation}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Senior Management Section */}
                {filteredData?.seniorManagement?.length ? (<section>
                    <h3 className="mb-6 text-xl font-semibold text-gray-800">Senior Management</h3>

                    <div className="grid grid-cols-2 gap-6 lg:grid-cols-3 md:grid-cols-3">
                        {filteredData?.seniorManagement?.map((manager, index) => (
                            <div key={index} className="mb-6">
                                <h4 className="mb-1 font-semibold text-black">
                                    {manager?.fullName}
                                </h4>
                                <p className="text-sm text-gray-600">{manager?.designation}</p>
                            </div>
                        ))}
                    </div>
                </section>) : null}

                {filteredData?.annualReports?.data?.length ? (
                    <section>
                        <h3 className="mb-6 text-xl font-semibold text-gray-800">Annual Reports</h3>

                        <div className="grid grid-cols-2 gap-6 lg:grid-cols-3 md:grid-cols-3">
                            {filteredData.annualReports.data.map((report, index) => (
                                <div
                                    key={index}
                                    onClick={() => window.open(report.values[0], "_blank")}
                                    className="flex w-full cursor-pointer items-center justify-between rounded-2xl border border-neutralOpacityDark-20 px-6 py-4 text-info-500"
                                >
                                    <p>{report.title}</p>
                                    <DownloadIcon width={18} height={18} />
                                </div>
                            ))}
                        </div>
                    </section>
                ) : null}
            </div>
        </div>
    );
};

export default BoardManagement;
